import { useRouter } from 'next/navigation';
import { PoiListScope, scopeLabels } from '../domain/models/PoiListScope';
import { ToggleList } from '../../../flights/overview/ui/FlightsScopeToggle';
import ShopDineRelaxScopeToggleItem from './ShopDineRelaxScopeToggleItem';
import { getShopDineRelaxListUrl } from '../../use-cases/getShopDineRelaxListUrl';
import { AirportCodes } from '../../../../types/airports';

interface IShopDineRelaxScopeToggleProps {
	activeScope: PoiListScope;
	setCurrentPageIndex: (currentPageIndex: number) => void;
	airportCode: AirportCodes;
}

export const ShopDineRelaxScopeToggle = ({
	activeScope,
	setCurrentPageIndex,
	airportCode,
}: IShopDineRelaxScopeToggleProps) => {
	const router = useRouter();

	const onToggleClick = (scope: PoiListScope) => {
		const url = getShopDineRelaxListUrl({ airportCode, scope });
		router.push(url, { scroll: false });
		setCurrentPageIndex(0);
	};

	return (
		<ToggleList>
			{scopeLabels.map(({ scope, label }) => (
				<ShopDineRelaxScopeToggleItem
					key={scope}
					scope={scope}
					label={label}
					activeScope={activeScope}
					onClick={onToggleClick}
				/>
			))}
		</ToggleList>
	);
};
